


import React from 'react'
import Image4withBG from "../../assets/borrower-page/Image4withBG.svg";
import { Box, Grid, Typography } from "@mui/material";
import Background from "../../assets/borrower-page/Background.svg";

export default function InstantMessaging() {
    return (
        <Grid container justifyContent="center" spacing={0}>
            <Grid item xs={11} md={11} lg={11} mt={0} mb={0} ml={0} mr={0}>
                <div>
                    <Box>
                        <Grid
                            container
                            minHeight="50vh"
                            alignItems="top"
                        //   pt={{ xs: 4, md: 1 }}
                        >
                            {/* Image Grid */}
                            {/* Background Image with Overlay */}
                            <Grid item xs={12} md={5} order={{ xs: 2, md: 1 }}> {/* Image second on mobile */}
                                <Box position="relative" my={{ md: "none", xs: 2 }}>
                                    {/* Background Image */}
                                    <img src={Background} width="100%" height="100%" alt="Background" />

                                    {/* Overlay Image */}
                                    <img
                                        src={Image4withBG} width={"100%"}
                                        style={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: "50%",
                                            transform: "translateX(-50%)" // Adjust horizontally to center
                                        }}
                                        alt="Overlay Image"
                                    />
                                </Box>
                            </Grid>

                            <Grid item md={2} order={{ xs: 3, md: 2 }}></Grid>

                            {/* Text Grid */}
                            <Grid
                                item
                                xs={12}
                                md={5}
                                textAlign={{ xs: "center", md: "start" }}
                                px={{ xs: 2 }}
                                order={{ xs: 1, md: 3 }}
                            >
                                <Typography
                                    variant="h2"
                                    component="h1"
                                    mb={2} mt={0}
                                    fontWeight={"bold"}
                                    lineHeight={"50px"}
                                >
                                    {`Instant Messaging Platform `}
                                </Typography>
                                <Typography variant="body1" mb={5}>
                                    {`Simplify your loan processing with our Instant Messaging Platform – swift connections, easy communication, and convenience at your fingertips. Making your loan journey smoother than ever!`}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </Grid>
        </Grid>
    )
}
